<template>
  <el-form ref="dataForm" :model="dataForm" label-width="0px" :disabled="isReadonly" :class="{ readOnlyStyle: isReadonly }" class="dataForm">
    <!-- 公司名称 -->
    <div class="pb50 messageWrap" v-if="businessType == 'SERVICE_TRANSFER' || businessType == 'COMPREHENSIVE_CUSTOMIZED'">
      <p class="messageTitle">
        <span>{{ $t("enroll.questionnaire.proposedCompanyName") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.proposedCompanyName"
          ref="questionnaire.proposedCompanyName"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.enter'),
              trigger: 'submit',
            },
          ]"
        >
          <el-input v-model="dataForm.questionnaire.proposedCompanyName" :placeholder="$t('common.placeholder.enter')" class="wd500"></el-input>
        </el-form-item>
      </div>
    </div>

    <!-- 你在马来西亚设立公司准备从事什么业务? -->
    <div class="messageWrap">
      <p class="messageTitle">
        <span>{{ $t("enroll.questionnaire.malaysia.workTitle") }}</span>
      </p>
      <div class="pt30">
        <el-form-item
          prop="questionnaire.businessPlan"
          ref="questionnaire.businessPlan"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.enter'),
              trigger: 'submit',
            },
          ]"
        >
          <el-input type="textarea" v-model="dataForm.questionnaire.businessPlan" :rows="4" :placeholder="$t('common.placeholder.enter')" class="wd500"></el-input>
        </el-form-item>
      </div>
    </div>

    <!-- 公司在马来西亚设立的原因 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span>{{ $t("enroll.questionnaire.malaysia.causeTitle") }}</span>
        <el-popover placement="bottom" trigger="hover">
          <div class="linkWrap">
            <p class="fs12">{{ $t("enroll.questionnaire.causeInfo") }}</p>
          </div>
          <span slot="reference" class="fs16 lucency otn el-icon-warning"></span>
        </el-popover>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.establishCause"
          ref="questionnaire.establishCause"
          :rules="[{ required: true, validator: validateCheckboxGroupWithOther, trigger: 'submit' }]"
        >
          <checkbox-group-with-other v-model="dataForm.questionnaire.establishCause" :options="byCountryFormatList('establishCauseData')" />
        </el-form-item>
      </div>
    </div>

    <!-- 公司注资以及未来运营的资金来源 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span>{{ $t("enroll.questionnaire.sourceTitle") }}</span>
        <el-popover placement="bottom" trigger="hover">
          <div class="linkWrap">
            <p class="fs12">{{ $t("enroll.questionnaire.causeInfo") }}</p>
          </div>
          <span slot="reference" class="fs16 lucency otn el-icon-warning"></span>
        </el-popover>
      </p>
      <div class="pt20">
        <el-form-item prop="questionnaire.fundsSource" ref="questionnaire.fundsSource" :rules="[{ required: true, validator: validateCheckboxGroupWithOther, trigger: 'submit' }]">
          <checkbox-group-with-other v-model="dataForm.questionnaire.fundsSource" :options="globalFormatList('moneySourceList')" />
        </el-form-item>
      </div>
    </div>

    <!-- 您的业务是否直接或间接与克里米亚、古巴、伊朗、朝鲜或叙利亚打交道？ -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        {{ $t("enroll.questionnaire.contactTitle") }}
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.businessDealWithDanger"
          ref="questionnaire.businessDealWithDanger"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.businessDealWithDanger">
            <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("common.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <div>
      <!--  您的供货商主要在哪些国家？ -->
      <div class="pt50 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.questionnaire.supplierTitle") }}
        </p>
        <div class="pt30">
          <el-form-item
            prop="questionnaire.supplierCountry"
            ref="questionnaire.supplierCountry"
            :rules="[
              {
                required: true,
                message: this.$t('common.placeholder.select'),
                trigger: 'submit',
              },
            ]"
          >
            <el-select v-model="dataForm.questionnaire.supplierCountry" multiple :placeholder="$t('common.placeholder.select')" class="wd500" filterable>
              <el-option v-for="item in globalFormatList('countryList')" :key="`supplierCountry-${item.value}`" :label="item.label" :value="item.value"></el-option>
              <el-option label="N/A" value="NONE"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>

      <!--  您的客户主要在哪些国家？ -->
      <div class="pt50 messageWrap">
        <p class="messageTitle">
          {{ $t("enroll.questionnaire.clientTitle") }}
        </p>
        <div class="pt30">
          <el-form-item
            prop="questionnaire.customerCountry"
            ref="questionnaire.customerCountry"
            :rules="[
              {
                required: true,
                message: this.$t('common.placeholder.select'),
                trigger: 'submit',
              },
            ]"
          >
            <el-select v-model="dataForm.questionnaire.customerCountry" multiple :placeholder="$t('common.placeholder.select')" class="wd500" filterable>
              <el-option v-for="item in globalFormatList('countryList')" :key="`customerCountry-${item.value}`" :label="item.label" :value="item.value"></el-option>
              <el-option label="N/A" value="NONE"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>

    <!-- 预期未来以现金(即非银行转款、非电子钱包转款)的交易比例（单选项） -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">{{ $t("enroll.questionnaire.financing") }}</p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.percentageOfTransactionsByCash"
          ref="questionnaire.percentageOfTransactionsByCash"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.percentageOfTransactionsByCash">
            <el-radio :label="1">{{ $t("enroll.questionnaire.financingOption01") }}</el-radio>
            <el-radio :label="0">{{ $t("enroll.questionnaire.financingOption02") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- 拟设公司的申请人/董事/股东是否为政治敏感人士，即在马来西亚境内、或其他国籍和地区，或任何一个国际组织目前担任敏感的政治职务？ -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span>{{ $t("enroll.questionnaire.malaysia.atDutiesTitle") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.memberPoliticallySensitive"
          ref="questionnaire.memberPoliticallySensitive"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.memberPoliticallySensitive">
            <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("common.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- 拟设公司的申请人/董事/股东是否为政治敏感人士，即在马来西亚境内、或其他国籍和地区，或任何一个国际组织曾经担任敏感的政治职务？ -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span>{{ $t("enroll.questionnaire.malaysia.onceDutiesTitle") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.memberPoliticallySensitivePast"
          ref="questionnaire.memberPoliticallySensitivePast"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.memberPoliticallySensitivePast">
            <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("common.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- 拟设公司的申请人/董事/股东是否为为目前或曾经担任政治敏感人士的直系亲属和密切关系人？ -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span>{{ $t("enroll.questionnaire.relativeTitle") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.memberPoliticallySensitiveRelative"
          ref="questionnaire.memberPoliticallySensitiveRelative"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.memberPoliticallySensitiveRelative">
            <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("common.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- (拟设)董事/股东是否事先有涉及欺诈或不诚实的刑事定罪？ -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span>{{ $t("enroll.questionnaire.criminalRecord") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.hasMemberDishonesty"
          ref="questionnaire.hasMemberDishonesty"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.select'),
              trigger: 'submit',
            },
          ]"
        >
          <el-radio-group v-model="dataForm.questionnaire.hasMemberDishonesty">
            <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("common.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </div>

    <!-- (拟设)公司的直接股东/董事信息 -->
    <div class="pt50 messageWrap" v-if="businessType == 'SERVICE_TRANSFER' || businessType == 'COMPREHENSIVE_CUSTOMIZED'">
      <p class="messageTitle">
        <span>{{ $t("enroll.questionnaire.informationProposed") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="companyMemberList"
          ref="companyMemberList"
          class="mb20"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.replenish'),
              trigger: 'submit',
            },
          ]"
        >
          <shareholder-director-information v-model="dataForm.companyMemberList" ref="shareholderDirectorInformationRef" :isReadonly="isReadonly" :isMalaysia="true" />
        </el-form-item>

        <!-- 定制化服务，是否已聘用EStar提供的名义董事 -->
        <el-form-item
          prop="questionnaire.appointNomineeDirector.type"
          ref="questionnaire.appointNomineeDirector.type"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.check'),
              trigger: 'submit',
            },
          ]"
          class="appointWrap"
          v-if="businessType == 'COMPREHENSIVE_CUSTOMIZED'"
        >
          <div class="flex-row">
            <span class="mr10 lh20">{{ $t("enroll.questionnaire.appointAny") }}</span>
            <el-radio-group v-model="dataForm.questionnaire.appointNomineeDirector.type" class="flex-row" @change="clearAgreementValidate('agreement')">
              <el-radio :label="1" class="flex-row">
                <div class="flex-row">
                  {{ $t("enroll.questionnaire.appointAnyYes") }}
                  <el-form-item
                    prop="questionnaire.appointNomineeDirector.name"
                    ref="questionnaire.appointNomineeDirector.name"
                    :rules="[
                      {
                        required: true,
                        message: this.$t('common.placeholder.enter'),
                        trigger: 'submit',
                      },
                    ]"
                    class="ml6"
                    v-if="dataForm.questionnaire.appointNomineeDirector.type == 1"
                  >
                    <el-input v-model="dataForm.questionnaire.appointNomineeDirector.name" :placeholder="$t('common.placeholder.enter')" class="wd150"></el-input>
                  </el-form-item>
                </div>
              </el-radio>
              <el-radio :label="0" class="flex-row">{{ $t("enroll.questionnaire.appointAnyNo") }}</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <!-- 我们同意聘用由星中商务推荐的名义董事1名，我们也理解该名义董事的行为造成的任何法律影响均与EStar无关。 -->
        <el-form-item
          prop="hasNomineeDirector"
          ref="hasNomineeDirector"
          class="agreementWrap"
          :rules="[
            {
              required:
                (businessType == 'SERVICE_TRANSFER' && applymentHasNomineeDirector) ||
                (businessType == 'COMPREHENSIVE_CUSTOMIZED' && dataForm.questionnaire.appointNomineeDirector.type)
                  ? true
                  : false,
              validator: validateMustCheckbox,
              trigger: 'submit',
            },
          ]"
          v-if="(businessType == 'SERVICE_TRANSFER' && applymentHasNomineeDirector) || businessType == 'COMPREHENSIVE_CUSTOMIZED'"
        >
          <el-checkbox v-model="dataForm.hasNomineeDirector" :true-label="1" :false-label="0">{{ $t("enroll.intitle.malaysia.check") }}</el-checkbox>
        </el-form-item>
      </div>
    </div>

    <!-- 最终受益人信息 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span>{{ $t("enroll.questionnaire.finalBeneficiary") }}</span>
        <el-popover placement="bottom" trigger="hover">
          <div class="linkWrap">
            <p class="fs12">
              {{ $t("enroll.questionnaire.tipeBeneficiary") }}
            </p>
            <p class="pt2">
              <span class="fs12">{{ $t("common.reference") }}</span>
              <a href="https://www.acra.gov.sg/how-to-guides/setting-up-and-maintaining-register-of-registrable-controllers-(rorc)" target="_blank" class="lh14">
                https://www.acra.gov.sg/how-to-guides/setting-up-and-maintaining-register-of-registrable-controllers-(rorc)
              </a>
            </p>
          </div>
          <span slot="reference" class="fs16 lucency ml14 otn el-icon-question"></span>
        </el-popover>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.ultimateBeneficiaryInfo"
          ref="questionnaire.ultimateBeneficiaryInfo"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.replenish'),
              trigger: 'submit',
            },
          ]"
        >
          <final-beneficiary-information
            v-model="dataForm.questionnaire.ultimateBeneficiaryInfo"
            :shareholderDataList="combinedShareholderList"
            ref="beneficiary"
            :isReadonly="isReadonly"
            :isMalaysia="true"
          />
        </el-form-item>
      </div>
    </div>

    <div v-if="businessType == 'SERVICE_TRANSFER' || businessType == 'COMPREHENSIVE_CUSTOMIZED'">
      <!-- (拟设)公司设立日期 -->
      <div class="pt50 messageWrap">
        <p class="messageSubTitle">
          <span>{{ $t("enroll.questionnaire.proposedCompanyIncorporationDate") }}</span>
        </p>
        <div class="pt20">
          <el-form-item prop="questionnaire.proposedCompanyIncorporationDate" ref="questionnaire.proposedCompanyIncorporationDate">
            <el-date-picker
              v-model="dataForm.questionnaire.proposedCompanyIncorporationDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :placeholder="$t('common.placeholder.select')"
              class="wd500"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>

      <!-- (拟设)公司财年结束日 -->
      <div class="pt50 messageWrap">
        <p class="messageSubTitle">
          <span>{{ $t("enroll.questionnaire.proposedCompanyFinancialYearEnd") }}</span>
        </p>
        <div class="pt20">
          <el-form-item prop="questionnaire.proposedCompanyFinancialYearEnd" ref="questionnaire.proposedCompanyFinancialYearEnd">
            <el-date-picker
              v-model="dataForm.questionnaire.proposedCompanyFinancialYearEnd"
              type="date"
              format="MM-dd"
              value-format="MM-dd"
              :placeholder="$t('common.placeholder.select')"
              class="wd500"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>

      <!-- (拟设)公司第一个财年结束日 -->
      <div class="pt50 messageWrap">
        <p class="messageSubTitle">
          <span>{{ $t("enroll.questionnaire.proposedCompanyFirstFinancialYearEnd") }}</span>
        </p>
        <div class="pt20">
          <el-form-item prop="questionnaire.proposedCompanyFirstFinancialYearEnd" ref="questionnaire.proposedCompanyFirstFinancialYearEnd">
            <el-date-picker
              v-model="dataForm.questionnaire.proposedCompanyFirstFinancialYearEnd"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :placeholder="$t('common.placeholder.select')"
              class="wd500"
            ></el-date-picker>
          </el-form-item>
        </div>
      </div>
    </div>

    <!-- 你是如何知道我们提供的公司服务(多选项，至少选一项) -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">
        <span>{{ $t("enroll.questionnaire.wayToGetThisTitle") }}</span>
      </p>
      <div class="pt20">
        <el-form-item
          prop="questionnaire.wayToGetThis"
          ref="questionnaire.wayToGetThis"
          :rules="[{ required: true, validator: validateCheckboxGroupWithOther, trigger: 'submit' }]"
        >
          <checkbox-group-with-other v-model="dataForm.questionnaire.wayToGetThis" :options="globalFormatList('understandWayList')" />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import ShareholderDirectorInformation from "../../components/ShareholderDirectorInformation";
import FinalBeneficiaryInformation from "../../components/FinalBeneficiaryInformation";
import { validateLocation, strToNum } from "@/utils/common";
import validatorMixin from "@/mixins/validatorMixin";
import { mapState, mapGetters } from "vuex";
export default {
  name: "EnrollQuestionnaireMalaysia",
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ShareholderDirectorInformation,
    FinalBeneficiaryInformation,
  },
  mixins: [validatorMixin],
  data() {
    return {
      dataForm: {
        questionnaire: {
          businessPlan: null,
          establishCause: [],
          fundsSource: [],
          businessDealWithDanger: null,
          supplierCountry: [],
          customerCountry: [],
          percentageOfTransactionsByCash: null,
          memberPoliticallySensitive: null,
          memberPoliticallySensitivePast: null,
          memberPoliticallySensitiveRelative: null,
          hasMemberDishonesty: null,
          ultimateBeneficiaryInfo: [],
          wayToGetThis: [],
          proposedCompanyName: null,
          appointNomineeDirector: {
            type: null,
            name: null,
          },
          proposedCompanyIncorporationDate: null,
          proposedCompanyFinancialYearEnd: null,
          proposedCompanyFirstFinancialYearEnd: null,
        },
        companyMemberList: [],
        hasNomineeDirector: null,
      },
      businessGenre: null,
      businessType: null,
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail", "applymentHasRegisteredAddress", "applymentHasNomineeDirector"]),
    ...mapGetters("constant", ["globalFormatList", "byCountryFormatList"]),
    ...mapGetters("language", ["getLanguage"]),
    /** 合并股东/董事列表（供最终受益人拷贝功能使用） */
    combinedShareholderList() {
      return this.dataForm.companyMemberList || [];
    },
  },
  methods: {
    // 移除[我们同意聘用由星中商务推荐的名义董事1名，我们也理解该名义董事的行为造成的任何法律影响均与EStar无关。]校验结果
    clearAgreementValidate(props) {
      this.$refs["dataForm"].clearValidate(props);
    },
    // 数据初始化处理
    dataInit() {
      const applymentDetailCopy = JSON.parse(JSON.stringify(this.applymentDetail));
      // 主体类型
      this.businessGenre = applymentDetailCopy.businessGenre;
      // 业务类型
      this.businessType = applymentDetailCopy.businessType;

      const questionnaireCopy = applymentDetailCopy.questionnaire || {};
      this.dataForm = {
        questionnaire: {
          businessPlan: questionnaireCopy.businessPlan || null,
          establishCause: questionnaireCopy.establishCause || [],
          fundsSource: questionnaireCopy.fundsSource || [],
          supplierCountry: questionnaireCopy.supplierCountry || [],
          customerCountry: questionnaireCopy.customerCountry || [],
          ultimateBeneficiaryInfo: questionnaireCopy.ultimateBeneficiaryInfo || [],
          wayToGetThis: questionnaireCopy.wayToGetThis || [],
          proposedCompanyName: questionnaireCopy.proposedCompanyName || null,
          proposedCompanyIncorporationDate: questionnaireCopy.proposedCompanyIncorporationDate || null,
          proposedCompanyFinancialYearEnd: questionnaireCopy.proposedCompanyFinancialYearEnd || null,
          proposedCompanyFirstFinancialYearEnd: questionnaireCopy.proposedCompanyFirstFinancialYearEnd || null,
          businessDealWithDanger: strToNum(questionnaireCopy.businessDealWithDanger),
          percentageOfTransactionsByCash: strToNum(questionnaireCopy.percentageOfTransactionsByCash),
          memberPoliticallySensitive: strToNum(questionnaireCopy.memberPoliticallySensitive),
          memberPoliticallySensitivePast: strToNum(questionnaireCopy.memberPoliticallySensitivePast),
          memberPoliticallySensitiveRelative: strToNum(questionnaireCopy.memberPoliticallySensitiveRelative),
          hasMemberDishonesty: strToNum(questionnaireCopy.hasMemberDishonesty),
          appointNomineeDirector: questionnaireCopy.appointNomineeDirector || { type: null, name: null },
        },
        companyMemberList: applymentDetailCopy.companyMemberList || [],
        hasNomineeDirector: strToNum(applymentDetailCopy.hasNomineeDirector),
      };
    },
    // 获取提交参数(由父级触发)
    getParamsData() {
      return {
        ...this.dataForm,
      };
    },
    // 触发必填校验(由父级触发) - 仅下一步时调用
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            if (this.businessType == "SERVICE_TRANSFER" || this.businessType == "COMPREHENSIVE_CUSTOMIZED") {
              // 校验公司的直接股东/董事信息
              if (this.$refs.shareholderDirectorInformationRef && !this.$refs.shareholderDirectorInformationRef.validate()) {
                reject("custom prompt: Shareholder/Director validation failed");
                return;
              }
            }
            resolve();
          } else {
            validateLocation(object, this);
            reject("custom prompt: Form verification failed");
          }
        });
      });
    },
  },
  created() {
    // isReadonly 时，applymentDetail 已存在于 vuex，自行初始化数据
    if (this.isReadonly) {
      this.dataInit();
    }
  },
};
</script>

<style lang="scss" scoped>
.messageTitle,
.messageSubTitle {
  border-radius: 2px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
}

.messageTitle:before {
  content: "*";
  margin-right: 4px;
  color: #f56c6c;
}

.dataForm ::v-deep input::-webkit-outer-spin-button,
.dataForm ::v-deep input::-webkit-inner-spin-button {
  appearance: none !important;
}

.dataForm ::v-deep input[type="number"] {
  appearance: textfield !important;
}

.dataForm ::v-deep {
  .el-checkbox {
    width: 470px;
    margin-right: 0px;
    padding-right: 30px;
    box-sizing: border-box;
  }

  .el-radio {
    margin-right: 18px;

    &:last-child {
      margin-right: 0;
    }
  }

  .el-radio__label {
    padding-left: 5px;
  }
}

.agreementWrap ::v-deep {
  .el-checkbox {
    width: 100% !important;
  }

  .el-checkbox__label {
    width: 98%;
    white-space: initial;
    font-size: 14px;
    vertical-align: top;
    margin-top: 8px;
  }
}

.appointWrap ::v-deep {
  .el-radio__inner {
    margin-top: 3px;
  }
}
</style>
